<template>
    <div class="order_bak2" v-portal>
        <div class="modal2">
            <div class="loading">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    directives: {
    portal: {
      //自定义指令用于外层渲染
      inserted: function (el, binding) {
        var value = binding.value;
        var app = document.querySelector("#app");
        console.log(app);
        try {
          if (value) {
            typeof value == "string"
              ? document.querySelector(value).appendChild(el)
              : value.appendChild(el);
          } else app.appendChild(el);
        } catch (error) {
          console.log(error);
        }
      },
    },
  },
}
</script>

<style scoped>
.order_bak2{
    position: fixed;
    background: rgba(0, 0, 0, 0.4);
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 10000;
}
.modal2 {
    position: fixed;
    width: 300px;
    height: 400px;
    left: 50%;
    top: 35%;
    transform: translate(-50%, -50%);
    /* background-color:#fff; */
    cursor: pointer;
    z-Index: 9000;
    text-align: center;
    padding: 20px;
}


.modal2 .loading {
    width: 150px;
    height: 15px;
    margin: 0 auto;
    margin-top: 100px;
}

.modal2 .loading span {
    display: inline-block;
    width: 15px;
    height: 100%;
    margin-right: 5px;
    border-radius: 50%;
    background: #fff;
    -webkit-animation: load 1.04s ease infinite;
}

.modal2 .loading span:last-child {
    margin-right: 0px;
}

@-webkit-keyframes load {
    0% {
        opacity: 1;
    }

    100% {
        opacity: 0;
    }
}

.modal2 .loading span:nth-child(1) {
    -webkit-animation-delay: 0.13s;
}

.modal2 .loading span:nth-child(2) {
    -webkit-animation-delay: 0.26s;
}

.modal2 .loading span:nth-child(3) {
    -webkit-animation-delay: 0.39s;
}

.modal2 .loading span:nth-child(4) {
    -webkit-animation-delay: 0.52s;
}

.modal2 .loading span:nth-child(5) {
    -webkit-animation-delay: 0.65s;
}



.modal img {
    display: block;
    margin: 40px auto 0px auto;
}
</style>